module.exports = __webpack_public_path__ + "img/support-email.8f1056af.svg";